import _ from 'lodash'
import SummaryColumn from 'modules/Station/components/SummaryColumn/SummaryColumn'
import { ReactComponent as DcDcConverterIcon } from 'icons/dc-dc-converter-icon.svg'
import BinaryBarChart from 'components/Charts/BinaryBarChart/BinaryBarChart'

const DcDcGroupsSummary = ({ data }) => {
  const count = data.length
  const healthyCount = data.filter((p) => p.healthy).length
  const unhealthyCount = count - healthyCount

  const summaryMap = {
    title: `DC:DC Groups`,
    titleIcon: <DcDcConverterIcon />,
    titleChart: (
      <BinaryBarChart
        positiveCount={healthyCount}
        negativeCount={unhealthyCount}
        tooltip={`Healthy DC:DC Groups: ${healthyCount} | Unhealthy DC:DC Groups: ${unhealthyCount}`}
        id="dcDcGroupsHealth"
      />
    ),
    sections: [
      {
        sectionTitle: 'Status',
        rows: [
          {
            label: 'In Rotation',
            value: _.filter(data, {
              outRotation: false,
            }).length.toLocaleString(),
          },
          {
            label: 'Ready',
            value: _.filter(data, { healthy: true }).length.toLocaleString(),
          },
          {
            label: 'Total',
            value: count.toLocaleString(),
          },
        ],
      },
    ],
  }

  return <SummaryColumn summaryMap={summaryMap} />
}

export default DcDcGroupsSummary
